import { IIcd10CodeSearchConfiguration } from '@assess/browser/icd10-code-search';

export const icd10CodeSearch: IIcd10CodeSearchConfiguration = {
  rootUrl: window.APP_CONFIG.CODE_SERVICE_ADDRESS,
};
